import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CNConsultation } from 'src/app/models/cnconsultation';

@Component({
  selector: 'app-contact-biometrics-simple',
  templateUrl: './contact-biometrics-simple.component.html',
  styleUrls: ['./contact-biometrics-simple.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactBiometricsSimpleComponent implements OnInit {

  @Input() contact: CNConsultation;

  constructor(private changeDetection: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  setHeight(ev: any) {
    this.contact.biometrics.height = ev.target.value;
    this.calculateBmi();
  }

  setWeight(ev: any) {
    this.contact.biometrics.weight = ev.target.value;
    this.calculateBmi();
  }

  calculateBmi() {
    const weight = parseFloat(this.contact.biometrics.weight.replace(',', '.'));
    let height = parseFloat(this.contact.biometrics.height.replace(',', '.'));
    if (height > 3) {
      // height provided in cm, convert to m
      height = height / 100;
    }
    if (!isNaN(weight) && !isNaN(height) && weight !== 0 && height !== 0) {
      this.contact.biometrics.bmi = (weight / (height * height)).toFixed(1).toString().replace('.', ',');
    }
  }
}
